const signatureSchema = function(state, props) {
  return {
    "name": {
      "ui:widget":"hidden"
    },
    "showInlineImages": {
      "ui:widget": "hidden"
    },
    "showInlinePdfs": {
      "ui:widget": "hidden"
    },
    "rizivNumber": {
      "ui:widget":"hidden"
    },
    "roles": {
      "ui:widget":"hidden"
    },
    "communicationEmail": {
      "ui:widget":"hidden"
    },
    "signature": {
      "ui:emptyValue": "",
      "ui:placeholder": "",
      "ui:widget": "FileWidget"
    },
  }
}

export default signatureSchema;
